import React from 'react';

const CheckBox = ({
  children,
  notInline,
  label,
  tooltip,
  onChange,
  checked,
  disabled = false
}) => (
  <label className={notInline ? '' : 'checkbox-inline'} title={tooltip}>
    <input
      disabled={disabled}
      type="checkbox"
      checked={checked}
      onChange={() => !disabled && onChange(!checked)}
    />
    {label}
    {children}
  </label>
);

export default CheckBox;
